import { put, call, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
// import ApiService from '../Services/ApiService';
// import AppActions from '../Stores/App/Actions';
import SiteProcessActions, { SiteProcessTypes } from '../Stores/SiteProcess/Actions';

// const getAppStore = state => state.app;

export function* siteProcessFetchSiteProcess() {
  try {
    yield put(SiteProcessActions.siteProcessFetchSiteProcessLoading(true));

    const result = [
      { proc_type: 'SITE_LIST_01', icon: 'fa fa-cubes' },
      { proc_type: 'SITE_FLOW_LIST_01', icon: 'fa fa-cubes' }
    ];
    yield put(SiteProcessActions.siteProcessFetchSiteProcessSuccess(result));

    /*
    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `site/indexItemFlow/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );
    
    if (result.isSuccess === true) {
      yield put(SiteProcessActions.siteProcessFetchSiteProcessSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
    */
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(SiteProcessActions.siteProcessFetchSiteProcessLoading(false));
  }
}

export const saga = [
  takeLatest(SiteProcessTypes.SITE_PROCESS_FETCH_SITE_PROCESS, siteProcessFetchSiteProcess)
];
